import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const NavigationAssignmentToolTip = (props) => (
  <div>
    The category of a break. Only select <strong>one</strong>. This will restrict a break into a specific section on the site and appears under the trending or featured image on a site’s homepage.
    <br/>
    <img src={makeToolTipUrl('break/nav/27.Navigation-assignment.png')} width="100%"/>
  </div>
);

export const FamilyCategoryTooltip = (props) => (
  <div>
    When “Yes,” the break will only appear on the navigation assignment selected and not the homepage.
  </div>
);

export const DirectURLTooltip = (props) => (
  <div>
    If “Yes,” blocks break from appearing on a site, but can still navigate to live URL.
  </div>
);

export const BlockGuestAccessTooltip = (props) => (
  <div>
  (Sponsored content only) Block guest readers from viewing a break.
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/breaks-nav-site-filter-tool-tips.jsx